<template>
  <div class="chat-navbar">
    <header class="chat-header">
      <!-- Avatar & Name -->
      <div class="d-flex align-items-center">
        <b-avatar
            :src="baseUrl+userInfo.selfieFileData"
            class="mr-1 cursor-pointer badge-minimal"
            size="36"
        />
        <router-link :to="{ name: 'apps-users-edit', params: { id: userInfo.userId } }">
          <h6 class="mb-0">
            {{ userInfo.name }} {{ userInfo.familyName }}
          </h6>
        </router-link>
      </div>

      <div>
        <b-button
            class="text-xs mt-1 p-1"
            type="submit"
            variant="primary"
            style="font-size: 12px!important;"
            @click="readMessages"
        >
          پیام ها خوانده شوند
        </b-button>
      </div>
    </header>
  </div>
</template>

<script>
import {BAvatar, BButton} from "bootstrap-vue";
import Helper from "@/libs/Helper";

export default {
  name: 'ChatHeader',
  props: {
    userInfo: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      baseUrl: Helper.baseUrl,
    }
  },
  components: {BButton, BAvatar},
  methods: {
    readMessages() {
      this.$emit('readMessages');
    }
  }
}
</script>

<style lang="scss">
@import "~@core/scss/base/pages/app-chat.scss";
@import "~@core/scss/base/pages/app-chat-list.scss";
</style>


<style scoped>

</style>
